// ##############################
// // // Dashboard View styles
// #############################

import {
  bigNumbers,
  primaryColor,
  dangerColor,
  successColor,
  tooltip,
  card,
  cardTitle,
  cardSubtitle,
  title
} from "assets/jss/material-dashboard-pro-react.jsx";

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

import hoverCardStyle from "assets/jss/material-dashboard-pro-react/hoverCardStyle.jsx";

const dashboardStyle = theme => ({
  ...modalStyle(theme),
  primary: {
    backgroundColor: primaryColor,
    color: "#FFFFFF",
  },
  dangerIcon: {
    color: dangerColor
  },
  mainDivMargins: {
    paddingRight: '0px',
    marginBottom: '5%',
    [theme.breakpoints.down("sm")]: {
      marginBottom: "5%",
    },
  },
  caseCards: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  fab: {
    position: "fixed",
    right: "25px",
    bottom: "20px",
    backgroundColor: "#FC6047",
    [theme.breakpoints.down("sm")]: {
      right: "25px",
      bottom: "90px"
    }
  },
  successIcon: {
    color: successColor
  },
  bigNumbers: {
    ...bigNumbers
  },
  ...card,
  ...hoverCardStyle,
  tooltip,
  cardTitle: {
    ...cardTitle,
    color: "#fff",
    marginTop: "0px",
    marginBottom: "3px"
  },
  cardTitle2: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px"
  },
  title,
  cardSubtitle: {
    ...title,
    color: "#fff",
    marginTop: "0",
    marginBottom: "0"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  cardProductTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
    textAlign: "center"
  },
  cardCategory: {
    color: "#000",
    fontSize: "14px",
    paddingTop: "10px",
    marginBottom: "0",
    marginTop: "0",
    margin: "0",
  },
  cardProductDesciprion: {
    textAlign: "center",
    color: "#999999"
  },
  senderAvatarDiv: {
    maxWidth: "7.666667%",
    [theme.breakpoints.down('sm')]: {
      maxWidth: "22%",
      paddingLeft: "28px !important"
    }
  },
  senderAvatarDiv2: {
    maxWidth: "7.666667%",
    [theme.breakpoints.down('sm')]: {
      maxWidth: "22%",
      paddingLeft: "32px !important"
    }
  },
  senderChatDiv: {
    marginTop: '0px',
    marginBottom: '25px',
    marginLeft: '0px',
    [theme.breakpoints.down('sm')]: {
      width: "115%"
    }
  },
  userInfo: {
    marginLeft: '90px',
    maxWidth: '5px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '16px',
      padding: '0 4px !important'
    }
  },

  userGridContainer: {

    marginRight: '0px',
    width: "109%",
    paddingLeft: "29%",
    [theme.breakpoints.down('sm')]: {
      paddingLeft: "0%",
      marginLeft: "6%",
      width: "93%"
    },
  },
  // userInfoDiv: {
  //   display: 'flex',
  //   flexDirection: 'column',
  //   width: '40px',
  //   height: '40px'
  // },
  userImg: {
    borderRadius: "50%",
    height: "40px",
  },
  userDiv: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginLeft: "5%"
    }
  },
  userDiv2: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginLeft: "11%"
    }
  },
  senderDiv: {
    marginLeft: "-10%",
    width: '70%',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '-60px',
      width: '89%'
    }
  },
  userGridItem: {
    minWidth: "85%",
    [theme.breakpoints.down('sm')]: {
      minWidth: "81%"
    }
  },
  threadsGrid: {
    padding: "0",
    [theme.breakpoints.down('sm')]: {
      paddingLeft: "13px !important"
    }
  },
  documents: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: "10%",
    paddingLeft: "1%",
    [theme.breakpoints.down('sm')]: {
      marginBottom: "25%",
    }
  },
  documentName: {
    paddingLeft: '10px'
  },
  userChatDiv: {
    marginTop: '0px',
    marginBottom: '25px',
    marginLeft: '100px',
    backgroundColor: '#6ed0e7',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '-6px',
      width: "114%"
    }
  },
  stats: {
    color: "#999999",
    fontSize: "12px",
    lineHeight: "22px",
    display: "inline-flex",
    "& svg": {
      position: "relative",
      top: "4px",
      width: "16px",
      height: "16px",
      marginRight: "3px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "4px",
      fontSize: "16px",
      marginRight: "3px"
    }
  },
  productStats: {
    paddingTop: "7px",
    paddingBottom: "7px",
    margin: "0"
  },
  successText: {
    color: successColor
  },
  upArrowCardCategory: {
    width: 14,
    height: 14
  },
  underChartIcons: {
    width: "17px",
    height: "17px"
  },
  price: {
    color: "inherit",
    "& h4": {
      marginBottom: "0px",
      marginTop: "0px"
    }
  },
  searchIcon: {
    color: "#999"
  },
  tab: {
    textAlign: "center",
    fontSize: "1rem",
    color: "#000",
    paddingTop: "5px"
  },
  tabHeader: {
    color: "#FC6047",
    fontWeight: "900"
  }
});

export default dashboardStyle;
